<template>
  <div class="page">
    <Menu :curName="'新闻资讯'"/>
    <div class="content">
      <div class="title">{{newsInfo.title}}</div>
      <div class="header">
        <span class="time">{{newsInfo.create_time|formatDate}}</span>
      </div>
      <div class="desc" v-html="newsInfo.news_desc"></div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import { NewsById } from "@/api/news.js";

export default {
  name: "newsDetail",
  data() {
    return {
      newsInfo: {}
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData: function() {
      NewsById(this.$route.params.id).then(resp => {
        if (resp != -1) {
          this.newsInfo = resp;
        }
      });
    }
  },
  filters: {
    formatDate: function(value) {
      if (value == undefined) {
        return;
      }
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },

  components: {
    Menu
  }
};
</script>


 <style scoped  lang="scss">
.content {
  width: 1200px;
  margin: 20px auto;
  .title {
    padding: 10px 20px;
    color: #222222;
    font-size: 1.6em;
    font-weight: bold;
  }
  .header {
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    .time {
      font-size: 1.4em;
      color: #717171;
    }
  }
  .desc {
    color: #3a3a3a;
    min-height: 500px;
    margin-top: 20px;
    padding: 10px 20px;
    ::v-deep p{
      font-size: 15px;
    }
  }
} 
</style>

<style>

</style>
